<template>
  <v-card color="white" tile flat style="overflow: hidden;">
    <v-card-text style="overflow: hidden; overflow-wrap: break-word;">
      <v-chip style="overflow: hidden; display: inline-grid;">
        <div style="overflow: hidden;">
          <SnippetCategory
            :standard-id="standardId"
            :category-id="question.category"
          />
        </div>
      </v-chip>
      <span class="pre">{{ question.text }}</span>
    </v-card-text>

    <v-card-text>
      <span v-if="question.chapters">
        <span
          v-for="(chaptergroup, chaptergroup_index) in getGroupedChapters(
            question.chapters
          )"
          :key="chaptergroup_index"
        >
          {{ chaptergroup_index }}:
          <span
            v-for="(chapter, chapter_index) in chaptergroup"
            :key="chapter_index"
          >
            <v-tooltip bottom>
              <span slot="activator">
                <v-chip label outline>{{ chapter.id }}</v-chip>
              </span>
              <span>{{ chapter.description }}</span>
            </v-tooltip>
          </span>
          <span>
            <br />
          </span>
        </span>
      </span>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.pre {
  tab-size: 2;
  -moz-tab-size: 2;
  white-space: pre;
}
</style>

<script>
import _ from "lodash";
import SnippetCategory from "@/components/snippets/SnippetCategory";
export default {
  props: {
    question: {
      type: Object,
      default() {
        return {
          category: "",
          text: "",
          chapters: null
        };
      }
    },
    standardId: {
      type: [Array, String],
      default: "",
      required: true
    }
  },
  components: {
    SnippetCategory
  },
  methods: {
    // TODO: @DEV Should be a representation of chapters by the store
    getGroupedChapters(chapters) {
      return _.groupBy(chapters, item => {
        return _.get(item, "standard", "no_standard");
      });
    }
  }
};
</script>
